export const SET_EVENT_SAVED_STATE = 'events/setSavedState';
export const VIEW_EVENT = 'events/viewEvent';
export const WILL_SHARE_EVENT = 'events/willShareEvent';
export const DID_SHARE_EVENT = 'events/didShareEvent';
export const SET_EVENTS = 'events/setEvents';

export const UPDATE_COLLECTION_EVENTS = 'collections/update_collection_events';
